export function Terms({ supportEmail }: { supportEmail?: string }) {
  return (
    <article className="prose">
      <h1>Terms of Service</h1>
      <p className="updated">
        This is a starter agreement for ReleaseMachine and is not a substitute for legal
        review.
      </p>

      <h2>The service</h2>
      <p>
        ReleaseMachine generates an automated, AI-assisted marketing campaign package
        based on the song information you submit, in exchange for a one-time payment.
        There is no subscription and no ongoing obligation on either side beyond
        fulfilling that one order.
      </p>

      <h2>What we don't do</h2>
      <p>
        ReleaseMachine does not analyze or listen to audio files — this version works from
        the text information you provide. We don't guarantee any specific promotional
        outcome, including chart performance, streaming numbers, or Spotify editorial
        playlist placement. We never post content to your social media accounts on your
        behalf.
      </p>

      <h2>Your content</h2>
      <p>
        You retain all rights to your song, lyrics, and any information you submit. You're
        responsible for making sure you have the rights to submit any lyrics or creative
        content you provide. The marketing copy we generate for your order is yours to
        use.
      </p>

      <h2>AI-generated content</h2>
      <p>
        Your campaign is generated using AI and is intended as a starting point for your
        promotional efforts. Review it before publishing anywhere — while we instruct the
        system not to fabricate accomplishments, press quotes, or statistics, you should
        still fact-check anything you plan to publish.
      </p>

      <h2>Payment</h2>
      <p>
        Payment is processed securely through Stripe. Your order is fulfilled
        automatically once payment is confirmed — see our Refund Policy for what happens
        if something goes wrong.
      </p>

      <h2>Availability</h2>
      <p>
        We aim for reliable, automated fulfillment, but no service is 100% uninterrupted.
        If generation fails, our system is designed to detect it and make it right — see
        the Refund Policy.
      </p>

      <h2>Changes</h2>
      <p>
        We may update these terms from time to time. Continued use of the service after a
        change constitutes acceptance of the updated terms.
      </p>

      <h2>Contact</h2>
      <p>
        Questions? Contact{" "}
        {supportEmail ? (
          <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
        ) : (
          "our support team"
        )}
        .
      </p>
    </article>
  );
}
